import { useMemo } from "react";
import { Alert, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { useGetAllContent } from "../../../../api/jeep-rally/content/content.hooks";
import { isJeepRallyAdmin } from "../Categories/utils/category.utils";
import {
  flattenContentToListItems,
  getContentApiErrorMessage,
  normalizeContents,
} from "./utils/content.utils";
import ContentsTable from "./List/_components/ContentsTable";

const ContentListPage = () => {
  const history = useHistory();
  const canManage = isJeepRallyAdmin();

  const { data, isLoading, isError, error } = useGetAllContent();

  const contents = useMemo(() => normalizeContents(data), [data]);
  const listItems = useMemo(
    () => flattenContentToListItems(contents),
    [contents]
  );

  const handleEdit = (item) => {
    const contentId = item?.contentId;
    const focusId = item?.focusId;
    if (!contentId || !focusId) return;
    history.push(`/jeep-rally/content/edit/${contentId}/${focusId}`, {
      content: item.document,
      focusId,
    });
  };

  if (isLoading) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-danger py-4">
            Failed to load content.{" "}
            {getContentApiErrorMessage(error, "Please try again.")}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title mb-0">Site Content ({listItems.length})</h4>
        </div>

        <div className="card-body">
          {!canManage && (
            <Alert variant="warning" className="mb-3">
              Admin access is required to edit site content.
            </Alert>
          )}

          {listItems.length === 0 ? (
            <div className="text-center py-4">
              <p className="text-muted mb-0">No content found</p>
            </div>
          ) : (
            <ContentsTable
              items={listItems}
              onEdit={handleEdit}
              canManage={canManage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentListPage;
